var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"arti-bottom",class:{ disabled: _vm.disableControl },attrs:{"to":_vm.nftLink(
      _vm.tokenBlockChainId || _vm.tokenId,
      _vm.currency,
      _vm.getContractAddressByCurrency(_vm.currency, _vm.tokenBlockChainId)
    )}},[_c('span',{staticClass:"first"},[_vm._v(_vm._s(_vm.formatNumber(_vm.minBidPrice))+" "+_vm._s(_vm.currency))]),(_vm.minBidPrice)?_c('span',{staticClass:"second"},[_c('span',{staticClass:"usd"},[_vm._v(_vm._s(_vm.formatNumber(_vm.convertToUsdPrice(_vm.minBidPrice, _vm.currency), true))+" USD")]),_c('span',{staticClass:"arti-label"},[_vm._v("Fixed price")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }